import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tailwind.css";
import "./styles/fonts.css";
import { DuviSharedAdminThemeProvider } from "@duvi-agency/theme";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* DuviSharedAdminThemeProvider writes the shared shell CSS custom
        properties (--shell-bg, --shell-surface, --accent,
        --shell-text-primary etc.) to :root so the @duvi-agency/ui shell
        components resolve their colours. Platform-admin uses the default
        theme — no per-niche accent override. */}
    <DuviSharedAdminThemeProvider>
      <App />
    </DuviSharedAdminThemeProvider>
  </StrictMode>,
);
